<template>
  <div>
    <DataTableAG :rowHeight="55" :columns="columns" :getcontentpath="getforgetmepath" jsonobject="forgetme"
      :buttonList="['Poista asiakkaan tiedot']" v-on:pressed-button1="deleteRequest" width="1200px" height="750px"
      archivecontentpath="2.0/newbe/deletenotifications" archiveparam="notificationids" />
  </div>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
export default {
  name: "Notifications",
  components: {
    DataTableAG,
  },
  methods: {
    deleteRequest(rowdata) {
      this.$notify.info({
        message: this.$t("loading_advertisement"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.postdata = JSON.stringify({
          id: rowdata.id
        });
      this.$http
        .post(this.deleterequestpath, this.postdata)
        .then((response) => {
          if (response.status == 200) {
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
  },
  data: () => ({
    getforgetmepath: "/1.0/front/forgetme",
    archivenotificationpath: "/1.0/newbe/archivenotification",
    deleterequestpath: "/1.0/front/forgetme",
    columns: [
      {
        field: "id",
        headerName: "Tunniste",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "tel",
        headerName: "Puhelinnumero",
        width: 125,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "email",
        headerName: "Sähköposti",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "created",
        headerName: "Luotu",
        width: 250,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "data",
        headerName: "Data",
        width: 125,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "account",
        headerName: "Käyttäjä",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() { },
};
</script>
